import { initialStateOptions } from '@/utils/pagination-utils';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  selectedStatus: null,
  searchText: null,
  listOptions: initialStateOptions(),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
